import { firebaseReducer } from "react-redux-firebase";
import { combineReducers } from "redux";
import { legacy_createStore as createStore} from 'redux'
import auth from './auth'
import nanoCompDataReducer from "./nanoCompDataReducer"

const rootReducer = combineReducers({
  auth,
  firebase: firebaseReducer,
  nanoCompDataReducer
});

export default rootReducer;